import { render, staticRenderFns } from "./FormatInput.vue?vue&type=template&id=7c53432e&scoped=true"
import script from "./FormatInput.vue?vue&type=script&lang=js"
export * from "./FormatInput.vue?vue&type=script&lang=js"
import style0 from "./FormatInput.vue?vue&type=style&index=0&id=7c53432e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53432e",
  null
  
)

export default component.exports